const translations = {};

translations["MSG_GUIDE"] = "Guide";
translations["MSG_NETWORK_ERROR_MESSAGE"] =
  "Could not display the page.\nPlease try again.";
translations["MSG_APP_ALL"] = "All";
translations["MSG_APP_BANNER_TITLE"] = "Manande Puzzle App";
translations["MSG_APP_BANNER_SUBTITLE"] =
  "~ Fun Programming Education for Kids ~";
translations["MSG_APP_BANNER_INSTALL_BTN"] = "Install";
translations["MSG_APP_BANNER_SHOW_BTN"] = "Show";

translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] =
  "Updating the app to the latest version.";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "A new version of the app is available.\nAn update is required to use the latest features.\nThe update will complete shortly.";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] =
  "Please enter a password of 6 characters or more.";
translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] =
  "Passwords do not match.";
translations["MSG_SIGN_IN_BTN"] = "Log In";
translations["MSG_SIGN_UP_BTN"] = "Sign Up";
translations["MSG_SIGN_IN_WITH_APPLE"] = "Continue with Apple";
translations["MSG_SIGN_UP_WITH_APPLE"] = "Continue with Apple";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "Continue with Google";
translations["MSG_SIGN_IN_WITH_MAIL"] = "Log In with Email";
translations["MSG_SIGN_UP_WITH_MAIL"] = "Sign Up with Email";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "Don't have an account? Sign up";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] =
  "Already have an account? Log in";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "Please enter your password";
translations["MSG_SIGN_LOGIN_FAILED"] =
  "Login failed. Please check your email address and password.";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "Passwords do not match";
translations["MSG_SIGN_UP_FAILED"] =
  "Account creation failed. Please try again.";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "Please enter your email address";
translations["MSG_SIGN_EMAIL_INVALID"] = "Please enter a valid email address";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] =
  "Failed to send password reset email. Please try again.";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] =
  "※We will send a password reset link to your registered email address.";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "Send Reset Email";
translations["MSG_SIGN_EMAIL_SENT"] = "Email sent";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] =
  "Password reset link has been sent.\nPlease check your email.";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "Back to Login";
translations["MSG_USER_NAME_LENGTH_LIMIT"] =
  "Please enter a name within 10 characters";
translations["MSG_USER_NAME_REQUIRED"] = "Please enter your name";
translations["MSG_USER_CREATE_FAILED"] =
  "User creation failed. Please try again.";
translations["MSG_USER_LATEST"] = "Latest";
translations["MSG_USER_LIST"] = "User List";
translations["MSG_USER_START_LEARNING_MESSAGE"] =
  "To start learning,\nplease create an account first.";
translations["MSG_USER_ADD_CHILD_ACCOUNT"] = "Add Child Account";
translations["MSG_USER_START"] = "Start";
translations["MSG_SIGN_USER_MAIL"] = "Email Address";
translations["MSG_SIGN_USER_PASSWORD"] = "Password";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "Re-enter Password";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "Login successful.";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] =
  "Account registration successful.";
// Account Promotion header
translations["MSG_ACCOUNT_PROMOTION_TITLE"] =
  "With Free Registration, You Can:";
translations["MSG_ACCOUNT_PROMOTION_MORE_LINK"] = "See account benefits";

// Account Promotion
translations["MSG_ACCOUNT_PROMOTION_SAVE_TITLE"] = "Auto-save your data";
translations["MSG_ACCOUNT_PROMOTION_SAVE_DESC"] =
  "Your learning progress and projects are saved in the cloud.";
translations["MSG_ACCOUNT_PROMOTION_SYNC_TITLE"] = "Sync across devices";
translations["MSG_ACCOUNT_PROMOTION_SYNC_DESC"] =
  "With the free plan, continue on any PC or tablet.";
translations["MSG_ACCOUNT_PROMOTION_MULTI_CHILD_TITLE"] =
  "Multiple child users";
translations["MSG_ACCOUNT_PROMOTION_MULTI_CHILD_DESC"] =
  "Free plan lets you create accounts for siblings and switch easily.";
translations["MSG_ACCOUNT_PROMOTION_CREATOR_SLOTS_TITLE"] = "Up to 5 creations";
translations["MSG_ACCOUNT_PROMOTION_CREATOR_SLOTS_DESC"] =
  "Free plan includes 5 project slots to explore more!";
translations["MSG_ACCOUNT_PROMOTION_FREE_COURSE_TITLE"] =
  "Unlimited free courses";
translations["MSG_ACCOUNT_PROMOTION_FREE_COURSE_DESC"] =
  "With the free plan, play and learn without daily limits. New courses added regularly.";
translations["MSG_ACCOUNT_PROMOTION_SIGNUP_BTN"] = "Sign Up";
translations["MSG_ACCOUNT_PROMOTION_LATER_BTN"] = "Later";

// Account Promotion Table
translations["MSG_ACCOUNT_PROMOTION_TABLE_HEADER_TRIAL"] = "Trial Plan";
translations["MSG_ACCOUNT_PROMOTION_TABLE_HEADER_FREE"] = "Free Plan";
translations["MSG_ACCOUNT_PROMOTION_TABLE_CURRENT_LABEL"] = "Before Registration";
translations["MSG_ACCOUNT_PROMOTION_TABLE_RECOMMENDED_LABEL"] = "After Registration";
translations["MSG_ACCOUNT_PROMOTION_TABLE_AFTER_SIGNUP_LABEL"] = "After Sign Up";
translations["MSG_ACCOUNT_PROMOTION_TABLE_USER_COUNT"] = "Number of Users You Can Add";
translations["MSG_ACCOUNT_PROMOTION_TABLE_USER_TRIAL"] = "Up to 1 person";
translations["MSG_ACCOUNT_PROMOTION_TABLE_USER_FREE"] = "Up to 2 people";
translations["MSG_ACCOUNT_PROMOTION_TABLE_CREATOR_COUNT"] =
  "Apps You Can Create in 'Create Freely'";
translations["MSG_ACCOUNT_PROMOTION_TABLE_CREATOR_TRIAL"] = "Up to 1 project";
translations["MSG_ACCOUNT_PROMOTION_TABLE_CREATOR_FREE"] = "Up to 5 projects";
translations["MSG_ACCOUNT_PROMOTION_TABLE_COURSE_ACCESS"] =
  "Number of Courses You Can Play in 'Learn with Courses'";
translations["MSG_ACCOUNT_PROMOTION_TABLE_COURSE_TRIAL"] = "Up to Stage 2";
translations["MSG_ACCOUNT_PROMOTION_TABLE_COURSE_FREE"] = "Up to Stage 7";
translations["MSG_ACCOUNT_PROMOTION_TABLE_SYNC"] = "Save Play Data to Cloud";
translations["MSG_ACCOUNT_PROMOTION_TABLE_SYNC_TRIAL"] = "✕";
translations["MSG_ACCOUNT_PROMOTION_TABLE_SYNC_FREE"] = "○";

// Redirect Sign Up modal (per source)
translations["MSG_REDIRECT_SIGNUP_TITLE_COURSE"] =
  "You've reached the course limit";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_COURSE"] =
  "Guests can only play Algorithm Stage 1 and 2\nIf you want to play more, please ask your parents or guardians";
translations["MSG_REDIRECT_SIGNUP_TITLE_CREATOR"] =
  "You can't create more projects";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_CREATOR"] =
  "Guests can create only 1 project\nIf you want to create more, please ask your parents or guardians";
translations["MSG_REDIRECT_SIGNUP_TITLE_CREATE_USER"] =
  "You can't add child users";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_CREATE_USER"] =
  "Guests cannot add child users\nIf you want to add users, please ask your parents or guardians";
translations["MSG_REDIRECT_SIGNUP_TITLE_USER_ACCOUNT"] =
  "You can't manage users";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_USER_ACCOUNT"] =
  "Managing users requires an account\nWith the free plan or higher, you can manage user settings\nRegistering an account gives you the free plan";
translations[
  "MSG_REDIRECT_SIGNUP_TITLE_PARENT_SETTINGS_USER_ACCOUNT_SETTINGS"
] = "Account management unavailable";
translations[
  "MSG_REDIRECT_SIGNUP_MESSAGE_PARENT_SETTINGS_USER_ACCOUNT_SETTINGS"
] =
  "Guests cannot modify account settings\nParent account registration required";
translations["MSG_REDIRECT_SIGNUP_TITLE_PARENT_SETTINGS_CHILD_USER_SETTINGS"] =
  "User management unavailable";
translations[
  "MSG_REDIRECT_SIGNUP_MESSAGE_PARENT_SETTINGS_CHILD_USER_SETTINGS"
] =
  "Guests cannot manage child users\nParent account registration required";
translations["MSG_REDIRECT_SIGNUP_TITLE_PARENT_SETTINGS_LINK_PARENTS_APP"] =
  "Guardian app unavailable";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_PARENT_SETTINGS_LINK_PARENTS_APP"] =
  "Guests cannot link with guardian app\nParent account registration required";
translations["MSG_REDIRECT_SIGNUP_TITLE_PARENT_SETTINGS_ENABLE_LAB"] =
  "Company code unavailable";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_PARENT_SETTINGS_ENABLE_LAB"] =
  "Guests cannot enter company authentication code\nParent account registration required";
translations["MSG_REDIRECT_SIGNUP_LEARN_MORE"] =
  "Learn more about account benefits";
translations["MSG_REDIRECT_SIGNUP_TO_PARENTS_BTN"] = "For Parents";
translations["MSG_SIGN_IN_FAILED_TITLE"] = "Login Failed";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] =
  "Incorrect email address or password.";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "Forgot Password?";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "Password Reset";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_SUCCESS_CONTENT"] =
  "A password reset link has been sent to the specified email address.";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] =
  "Current Password";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "New Password";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] =
  "Confirm Password";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SEND_BTN"] = "Change";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] =
  "Password changed successfully.";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] =
  "Incorrect password entered.";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "This email address is already in use.";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "Parent";

translations["MSG_DATETIME_PERIOD"] = "Period";
translations["MSG_DATETIME_PERIOD_RECENTLY"] = "Recently";
// Example US format
translations["MSG_DATETIME_FORMAT_HOUR"] = "hr";
translations["MSG_DATETIME_FORMAT_MINUTE"] = "min";

translations["MSG_INEXUS_OFFICIAL"] = "Manande Puzzle";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "Manapuzzle Support";
translations["MSG_REVIEW_RATING_TITLE"] = "Please rate\n'Manande Puzzle'!";
translations["MSG_REVIEW_FEEDBACK_TITLE"] = "Suggestion Box";
translations["MSG_REVIEW_SEND_RATING_CONFIRM"] = "Send";
translations["MSG_REVIEW_SEND_FEEDBACK_CONFIRM"] = "Send Feedback";
translations["MSG_REVIEW_THANKS_BUBBLE_TEXT"] = "Thank you\nvery much!";
translations["MSG_REVIEW_FEEDBACK_THANKS_TEXT"] =
  "We look forward to your continued\nsupport of 'Manande Puzzle'.";

translations["MSG_REVIEW_FEEDBACK_TYPE_APP"] = "Entire App";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE"] = "'Learn with Courses'";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR"] = "'Create Freely'";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "No complaints";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] =
  "Don't know\nhow to use";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "Difficult to use";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "Too difficult";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "Too easy";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "Too many\nstages";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "Too few\nstages";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] =
  "Can't create\nwell";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] =
  "Difficult to\nuse";
translations["MSG_REVIEW_FEEDBACK_PLACEHOLDER"] = "Write freely here";
translations["MSG_USER_PROFILE_ADD_USER_TITLE"] = "Add User";
translations["MSG_USER_PROFILE_ADD_USER_BTN"] = "Add";
translations["MSG_USER_PROFILE_ADD_USER_MESSAGE"] = "Please name the new user.";
translations["MSG_USER_PROFILE_CHANGE_USER"] = "Switch User";
translations["MSG_USER_PROFILE_CHANGE_USER_TITLE"] = "Switch user?";
translations["MSG_USER_PROFILE_CHANGE_USER_MESSAGE"] =
  "Go to the user list page to switch users.";
translations["MSG_USER_PROFILE_CHANGE_USER_SUCCESS"] = "Switched user.";
translations["MSG_USER_PROFILE_CHANGE_USER_FAILED"] = "Failed to switch user.";
translations["MSG_USER_PROFILE_MAX_USER_TITLE"] = "Cannot Add User";
translations["MSG_USER_PROFILE_MAX_USER_MESSAGE"] =
  "Currently, only up to 2 users can be created.\nWe will notify you when it becomes possible to create more than 2 users.";
translations["MSG_USER_PROFILE_SHOW_USER_LIST_BTN"] = "More";
translations["MSG_USER_PROFILE_USER_STATUS"] = "Status";
translations["MSG_USER_SELECTION_PROMPT"] = "Choose who will play";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "Name%{random}";
translations["MSG_GUEST_USER_PROFILE_DEFAULT_NAME"] = "Guest%{random}";
translations["MSG_USER_PROFILE_FIELD_NAME"] = "Nickname";
translations["MSG_USER_PROFILE_FIELD_NAME_PLACEHOLDER"] = "Enter nickname";
translations["MSG_USER_PROFILE_INPUT_TITLE"] =
  "Let's choose your name and icon!";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT"] = "Give yourself a name";
translations["MSG_USER_PROFILE_SELECT_ICON_TITLE"] = "Choose your icon";
translations["MSG_USER_PROFILE_FIELD_GENDER"] = "Gender";
translations["MSG_USER_PROFILE_FIELD_GENDER_MALE"] = "Male";
translations["MSG_USER_PROFILE_FIELD_GENDER_FEMALE"] = "Female";
translations["MSG_USER_PROFILE_FIELD_GENDER_NONE"] = "Background";
translations["MSG_USER_PROFILE_FIELD_GENDER_ALL"] = "All";
translations["MSG_USER_PROFILE_FIELD_AGE"] = "Age";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY"] = "Birthday";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_MONTH"] = "Month";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_DAY"] = "Day";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_AGE"] = "years old";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_MONTH_ERROR"] =
  "Please use a number between 1 and 12.";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_DAY_ERROR"] =
  "Please use a number between 1 and 31.";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_AGE_ERROR"] =
  "Please use a number between 0 and 99.";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_MONTH_PLACEHOLDER"] = "1";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_DATE_PLACEHOLDER"] = "1";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_AGE_PLACEHOLDER"] = "0";
translations["MSG_USER_PROFILE_STATUS_COURSE_CLEARED"] = "Courses\nCleared";
translations["MSG_USER_PROFILE_STATUS_PROJECTS"] = "Apps\nCreated";
translations["MSG_USER_PROFILE_STATUS_PUBLISHED_PROJECTS"] = "Apps\nPublished";
translations["MSG_USER_PROFILE_STATUS_PROJECT_RECEIVED_FAVORITE"] =
  "Likes\nReceived";
translations["MSG_USER_PROFILE_PROGRESS"] = "Record";
translations["MSG_USER_PROFILE_PROGRESS_NEW_TITLE"] = "New!";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_LEVEL_TITLE"] = "Level";
translations["MSG_USER_PROFILE_PROGRESS_COURSE"] = "Learn with\nCourses";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CHART_DATE_TITLE"] = "Day";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_TITLE"] =
  "Number Cleared";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR"] = "Create\nFreely";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_START"] =
  "Total";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_END"] =
  "People";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_START"] =
  "Total";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_END"] =
  "Likes";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_VIEWED_TITLE"] =
  "Visitors";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_FAVORITED_TITLE"] =
  "Likes";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY"] =
  "Let's create an app!";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_GOTO_BTN"] =
  "Go to 'Create Freely'";
translations["MSG_USER_PROFILE_INFO"] = "Me";
translations["MSG_USER_PROFILE_ICON_BTN"] = "Change Icon";
translations["MSG_USER_PROFILE_CASE_BTN"] = "Change Case";
translations["MSG_USER_PROFILE_STOCK"] = "Materials";
translations["MSG_USER_PROFILE_SETTING"] = "Settings";
translations["MSG_USER_PROFILE_NAME_ERROR_TITLE"] = "Registration failed.";
translations["MSG_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "Contains unusable characters or text. Please try again.";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_TITLE"] =
  "Registration failed.";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "Contains unusable characters or text. Please try again.";
translations["MSG_USER_PROFILE_MESSAGE"] = "Mail";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_TITLE"] = "%{type} Inquiry";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "Thank you for your inquiry!\nPlease write your question in the input field below.";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_INPUT_AUTO_REPLY"] =
  translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"];
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] = " joined.";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_SEND_BTN"] = "Send";

// Official welcome messages (dynamic index 0..3)
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_0"] =
  "%{name}, welcome to 'Manande Puzzle'!";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_1"] =
  "In 'Manande Puzzle', you can learn programming while having fun playing puzzles.\nFirst, try starting with 'Learn with Courses' to learn how to play and study in order!";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_2"] =
  "Once you have a general understanding of algorithms and programming methods, try creating your own app as you like in 'Create Freely'.";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_3"] =
  "Let's try 'Manande Puzzle'!";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING"] = " sent a rating.";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING_AUTO_REPLY"] =
  "Thank you for your rating!";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_AUTO_REPLY"] =
  "Thank you for your feedback!";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TITLE"] = "Feedback";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TYPE_OTHER"] =
  "・Other:";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER"] = "Write freely here";
translations["MSG_USER_PROFILE_MESSAGE_PUBLISHED_PROJECT_MESSAGE"] =
  'Published the app "%{name}".';

translations["MSG_TOP_TUTORIAL_FIRST_WELCOME_MESSAGE"] =
  "If you're new,\nwatch the tutorial!";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_1"] =
  "Let's do our best\ntogether today!";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_2"] =
  "Let's have fun learning\nwith puzzles!";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_3"] =
  "Learn programming\nwith me!";
translations["MSG_TOP_TUTORIAL_APP_START"] = "Start";
translations["MSG_TOP_TUTORIAL_START"] = "Watch Tutorial";
translations["MSG_TOP_TUTORIAL_DONOT_SHOW"] = "Don't show next time";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_1"] = "About 'Manande Puzzle'";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_2"] = "About 'Learn with\nCourses'";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_3"] = "About 'Create Freely'";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_4"] = "Help Button and\nMy Page";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_5"] = "About the Menu\nfor Parents";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_6"] = "Configure App\nSettings";
translations["MSG_TOP_TUTORIAL_CLOSE_PAGE"] = "Close this screen";
translations["MSG_TOP_TUTORIAL_NEXT_PAGE"] = "Next";
translations["MSG_TOP_TUTORIAL_START_APP"] = "Start 'Manande Puzzle'";

translations["MSG_ONBOARDING_STEP_TITLE_1"] = "「まなんでパズル」\nについて";
translations["MSG_ONBOARDING_STEP_TITLE_2"] = "「コースでまなぶ」\nについて";
translations["MSG_ONBOARDING_STEP_TITLE_3"] = "「じゆうにつくる」\nについて";
translations["MSG_ONBOARDING_STEP_TITLE_4"] = "ヘルプボタンと\nマイページ";
translations["MSG_ONBOARDING_STEP_TITLE_5"] =
  "保護者の方用の\nメニューについて";
translations["MSG_ONBOARDING_STEP_TITLE_6"] = "アカウントの\n作成";
translations["MSG_ONBOARDING_STEP_6_MAIN_TITLE"] = "Welcome to Manande Puzzle!";
translations["MSG_ONBOARDING_STEP_6_SIGN_UP_TITLE"] = "Sign Up";
translations["MSG_ONBOARDING_STEP_6_SIGN_IN_TITLE"] = "Sign In";
translations["MSG_ONBOARDING_STEP_6_GUEST_TITLE"] = "Try as Guest";
translations["MSG_ONBOARDING_FIRST_TIME"] = "First Time";
translations["MSG_ONBOARDING_FIRST_TIME_SUB"] = "Start a new adventure!";
translations["MSG_ONBOARDING_EXISTING_USER"] = "Already Playing";
translations["MSG_ONBOARDING_EXISTING_USER_SUB"] =
  "Parents (Log In or Sign Up)";

// AuthSelection
translations["MSG_AUTH_SELECTION_TITLE"] = "Choose Your Account";
translations["MSG_AUTH_SELECTION_SUBTITLE"] = "Please select login or sign up";
translations["MSG_AUTH_SELECTION_INSTRUCTION"] =
  "Already have an account? Log in. New to Manande Puzzle? Sign up.";
translations["MSG_AUTH_SIGN_IN"] = "Log In";
translations["MSG_AUTH_SIGN_IN_DESC"] = "Sign in with existing account";
translations["MSG_AUTH_SIGN_UP"] = "Sign Up";
translations["MSG_AUTH_SIGN_UP_DESC"] = "Create a new account";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "Notification";

translations["MSG_BACK_BTN"] = "Back";
translations["MSG_CLOSE_BTN"] = "Close";
translations["MSG_CANCEL_BTN"] = "Cancel";
translations["MSG_CONFIRM_BTN"] = "Confirm";
translations["MSG_STOP_BTN"] = "Stop";
translations["MSG_DELETE_BTN"] = "Delete";
translations["MSG_PARENTS_CANCEL_BTN"] = "Cancel";
translations["MSG_PARENTS_CONFIRM_BTN"] = "Confirm";
translations["MSG_PARENTS_DELETE_BTN"] = "Delete";
translations["MSG_PARENTS_KIDS_USER_DELETE_BTN"] = "Delete this user";

translations["MSG_ERROR_RELOAD_BTN"] = "Retry";
translations["MSG_ERROR_TITLE"] = "Could not complete the process correctly.";
translations["MSG_ERROR_MESSAGE"] =
  "Please try again.\nIf this screen appears again after retrying, please consult a parent.";
// Example US format

translations["MSG_TOAST_FAILED"] = "Failed";
translations["MSG_TOAST_SEND_FAILED"] = "Send failed";
translations["MSG_TOAST_EDIT_SUCCESS"] = "Changed successfully";
translations["MSG_TOAST_DELETED_SUCCESS"] = "Deleted successfully";
translations["MSG_TOAST_PUBLISHED_SUCCESS"] = "Published successfully";
translations["MSG_TOAST_DISABLE_PUBLISHED_SUCCESS"] =
  "Unpublished successfully";
translations["MSG_TOAST_ENABLE_COPIED_SUCCESS"] = "Copying allowed";
translations["MSG_TOAST_DISABLE_COPIED_SUCCESS"] = "Copying disallowed";
translations["MSG_TOAST_RESTORE_SUCCESS"] = "App restored";
translations["MSG_TOAST_COPY"] = "Copied.";
translations["MSG_TOAST_PAST"] = "Pasted.";
translations["MSG_TOAST_UNDO"] = "Undone.";
translations["MSG_TOAST_REDO"] = "Redone.";
translations["MSG_TOAST_INSERT_ASSET_IMAGE_SUCCESS"] = "Image added.";
translations["MSG_TOAST_INSERT_ASSET_TEMPLATE_SUCCESS"] = "Template added.";
translations["MSG_TOAST_CONTACT_SEND"] = "Inquiry sent.";
translations["MSG_SETTING_TOP_TUTORIAL"] = "App Startup Screen";
translations["MSG_SETTING_TOP_TUTORIAL_SHOW"] = "Show at start";
translations["MSG_SETTING_TOP_TUTORIAL_NOT_SHOW"] = "Do not show";
translations["MSG_SETTING_APP_LANGUAGE"] = "App Display Language";
translations["MSG_SETTING_SOUND"] = "Sound Effects";
translations["MSG_SETTING_BGM"] = "Music";
translations["MSG_SETTING_PARENT_GATE"] = "For Parents";
translations["MSG_SETTING_GO_TO_TOP"] = "Top Page";
translations["MSG_SETTING_GO_TO_CONTACT"] = "Contact Us";
translations["MSG_SETTING_GO_TO_REVIEW"] = "Rate App";
translations["MSG_SETTING_GO_TO_TUTORIAL"] = "Tutorial";
translations["MSG_SETTING_GO_TO_PARENTS_LINK"] = "Guardian App";
translations["MSG_SETTING_GO_TO_LAB"] = "Enter Company Code";
translations["MSG_SETTING_CLOSE_BTN"] = "Close this screen";
translations["MSG_SETTING_BACK_TO_BTN"] = "Back to previous screen";

translations["MSG_SETTING_TITLE_TOP"] = "Parent Menu";
translations["MSG_SETTING_CATEGORY_TITLE_APP_ACCOUNT"] = "Account";
translations["MSG_SETTING_CATEGORY_TITLE_APP_CONTENT"] = "Content";
translations["MSG_SETTING_CATEGORY_TITLE_APP_INFO"] = "App";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "View Course Answers";
translations["MSG_SETTING_TITLE_PARENTS_LINK"] = "Guardian App";
translations["MSG_SETTING_TITLE_ENABLE_LAB"] = "Content Authentication";
translations["MSG_SETTING_TITLE_PARENTS_USER_ACCOUNT"] = "Account Management";
translations["MSG_SETTING_TITLE_PARENTS_USER_PROFILE"] = "User Management";
translations["MSG_SETTING_TITLE_SUBSCRIPTION"] = "Plan Purchase";
translations["MSG_SETTING_TITLE_SIGN_PASSWORD_CHANGE"] = "Change Password";
translations["MSG_SETTING_TITLE_PARENTS_USER_UNSUBSCRIBE"] = "Delete Account";
translations["MSG_SETTING_TITLE_NOTIFICATION"] = "Notifications";
translations["MSG_SETTING_MENU_PROJECT_PUBLISH"] = "Allow publishing apps";
translations["MSG_SETTING_MENU_PROJECT_COPIED"] = "Allow apps to be copied";
translations["MSG_SETTING_MENU_LANGUAGE"] = "App Display Language";
translations["MSG_SETTING_MENU_COURSE_ANSWER_BTN"] = "View Course\nAnswers";
translations["MSG_SETTING_MENU_NOTIFICATION_TITLE"] =
  translations["MSG_SETTING_TITLE_NOTIFICATION"];
translations["MSG_SETTING_MENU_PARENTS_USER_BTN"] =
  translations["MSG_SETTING_TITLE_PARENTS_USER_PROFILE"];
translations["MSG_SETTING_MENU_SIGN_WARNING_TITLE"] = "Create an Account?";
translations["MSG_SETTING_MENU_SIGN_WARNING_MESSAGE"] =
  "As a guest user, you can only play 1 course per day and create only 1 project in Free Creation.\nWith an account, you can play courses unlimited times every day and create up to 5 projects in Free Creation!\nYou will be redirected to the account creation page.";

translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "Go to 'Manande Puzzle' site";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "Terms of Service";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "Privacy Policy";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "Contact Us";
translations["MSG_SETTING_APP_SETTING_USER_ACTIVE"] = "Activate this user";
// Example using count
translations["MSG_SETTING_DATA_DELETE_SUCCESS"] = "User deleted.";
translations["MSG_SETTING_PARENTS_MAX_USER_TITLE"] = "Cannot Add User";
translations["MSG_SETTING_PARENTS_MAX_USER_MESSAGE"] =
  "Currently, only up to 2 users can be created.\nWe will notify you when it becomes possible to create more than 2 users.";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "Activate User";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] =
  "Activate this user.";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "Deactivate User";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] =
  "Deactivate this user.";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] =
  "Cannot Activate";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "The maximum number of active users is 4.\nTo activate this user, please deactivate (or delete) another unnecessary user.";
translations["MSG_SETTING_PARENTS_ADD_DEVICE_USER_MAX_WARNING_TITLE"] =
  "Please check the activation status of the added user";
translations["MSG_SETTING_PARENTS_ADD_DEVICE_USER_MAX_WARNING_MESSAGE"] =
  "The total number of users in the logged-in account exceeds 4.\nThe maximum number of concurrently active users is 4.\nIf you want to activate the user added this time, please deactivate (or delete) other unnecessary users.";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] =
  "Cannot Change";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "At least one user is required.\nCannot reduce the number of users further.";
translations["MSG_SETTING_PARENTS_REMOVE_KIDS_USER_TITLE"] = "Delete User";
translations["MSG_SETTING_PARENTS_REMOVE_KIDS_USER_MESSAGE"] =
  "Deleting the user will remove all data for this user.\nYou will no longer be able to use this user.";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "Log Out";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "Logging out of the account will prevent you from playing with the current user.\nUser information is saved in the account, so if you want to play with the same user again, please log in again with this account.";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] =
  "【Important】Please Note";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "Deleting your account from 'Manande Puzzle' will delete all of the following data:\n・Registered profile and account information.\n・Registered user information for everyone.\n・Apps created by users in 'Create Freely'.\n・All grades and clear achievements for 'Learn with Courses' cleared by users.\n・'Talk History' etc. conducted by users.\n* 【Important】Deleting the logged-in account will delete all data related to this account, so please be very careful.\n* 【Important】This operation cannot be recovered under any circumstances. Please be very careful when deleting your account.";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] =
  "Please tell us the reason for deleting your account.";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] =
  "Are you sure you want to delete your account?";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "Deleting the account will remove all data including the account and users.\nAccount deletion cannot be recovered. Please be careful.";
translations["MSG_SETTING_PARENTS_USER_PROFILE_NAME"] = "Display Name";
translations["MSG_SETTING_PARENTS_USER_PROFILE_SAVE_BTN"] = "Save";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL"] = "Email Address";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL_VERIFIED"] =
  "Email Verification";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL_VERIFIED_DONE"] =
  "Verified";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL_VERIFIED_NOT_YET"] =
  "Send verification link";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT"] =
  "Link with Social\nAccount";
translations[
  "MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"
] = "Cannot Link";
translations[
  "MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"
] = "Social account is already linked to another account.";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_WITH_APPLE"] =
  "Link with Apple";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_WITH_GOOGLE"] =
  "Link with Google";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_UNLINK_WITH_APPLE"] =
  "Unlink Apple";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_UNLINK_WITH_GOOGLE"] =
  "Unlink Google";
translations["MSG_SETTING_PARENTS_USER_PROFILE_CREATED_AT"] =
  "Account Registration Date";
translations["MSG_SETTING_PARENTS_USER_KIDS_PROFILE_CREATED_AT"] =
  "Registration Date";
translations["MSG_SETTING_PARENTS_USER_PROFILE_LATEST_AT"] = "Last Login Date";
translations["MSG_SETTING_PARENTS_USER_PROFILE_GOTO_CHANGE_PASSWORD_BTN"] =
  "Change Password";
translations["MSG_SETTING_PARENTS_USER_PROFILE_SIGN_OUT_BTN"] = "Log Out";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] =
  "Delete Account";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ADD_USER"] = "Add New User";
translations["MSG_SETTING_PARENTS_USER_PROFILE_DISPLAY_NAME_LIMIT"] =
  "Please enter within %{limit} characters.";

translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "Select Course";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "Select Stage";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "Select Level";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "Stage";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "Level";

translations["MSG_SETTING_PARENTS_LINK_DOWNLOAD_TITLE"] =
  "Download the Guardian App from the App Store";
translations["MSG_SETTING_PARENTS_LINK_DOWNLOAD_DESCRIPTION"] =
  "If you want to download the app without using a QR code, please download it from the respective app store using the icons below.";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_TITLE"] =
  "Add User to Guardian App";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_DESCRIPTION"] =
  "If you want to add a user without using a QR code, please enter this authentication code in the 'Guardian App'.";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] =
  "Authentication Code";

translations["MSG_CONTACT_TITLE"] = "Contact Us";
translations["MSG_CONTACT_TYPE_TITLE"] = "Select the type of inquiry";
translations["MSG_CONTACT_DETAIL_TITLE"] = "Please tell us the details";
translations["MSG_CONTACT_TYPE_HOW_TO"] = "Don't know\nhow to use";
translations["MSG_CONTACT_TYPE_BUG"] = "Doesn't work\nproperly";
translations["MSG_CONTACT_TYPE_REQUEST"] = "Feature\nrequest";
translations["MSG_CONTACT_TYPE_OTHER"] = "Other\nquestions";
translations["MSG_CONTACT_SEND_BTN"] = "Send Inquiry";

translations["MSG_PARENT_GATE_WARNING"] =
  "Please have an adult\nconfirm this page.";
translations["MSG_PARENT_GATE_TITLE"] = "For Parents";
translations["MSG_PARENT_GATE_DESCRIPTION"] =
  "The following screen is the settings and account information page for parents.\nTo display the screen, please tap the images below in the indicated order and then press the proceed button.";
translations["MSG_PARENT_GATE_CLOSE_BTN"] =
  translations["MSG_SETTING_CLOSE_BTN"];
translations["MSG_PARENT_GATE_CONFIRM_BTN"] = "Proceed";
translations["MSG_PARENT_GATE_QUESTION_TITLE"] =
  "Tap the images in this order:";
translations["MSG_PARENT_GATE_SHAPE_RECT"] = "Square";
translations["MSG_PARENT_GATE_SHAPE_STAR"] = "Star";
translations["MSG_PARENT_GATE_SHAPE_CIRCLE"] = "Circle";
translations["MSG_PARENT_GATE_SHAPE_TRIANGLE"] = "Triangle";
// MSG_PARENTS_PROFILE_DEFAULT_NAME is already defined above

translations["MSG_COURSE_COMING_SOON_WARNING_MESSAGE"] =
  "This cassette can't be played yet.\nPlease wait a little longer!";
translations["MSG_COURSE_START_BTN"] = "Start";
translations["MSG_COURSE_GOTO_MAP_BTN"] = "Go to Map";
translations["MSG_COURSE_STAGE_CLEAR_TITLE"] = "Cleared up to here!";
translations["MSG_COURSE_LEVEL_OVERVIEW_SUMMARY"] =
  "What you'll learn in this level";
translations["MSG_COURSE_LEVEL_OVERVIEW_START_BTN"] = "Start";
translations["MSG_COURSE_GAME_TIPS_NEXT_BTN"] = "Next";
translations["MSG_COURSE_GAME_TIPS_BACK_BTN"] = "Back";
translations["MSG_COURSE_GAME_TIPS_ACTION_BTN"] = "Try it";
translations["MSG_COURSE_GAME_HINT_BTN"] = "Hint";
translations["MSG_COURSE_GAME_CLEAR"] = "Clear";
translations["MSG_COURSE_GAME_SCORE_TEXT"] = "Items obtained";
translations["MSG_COURSE_GAME_SCORE_STATUS"] = "/%{total}";
translations["MSG_COURSE_GAME_START_BTN"] = "Start!";
translations["MSG_COURSE_GAME_RESET_BTN"] = "Retry";
translations["MSG_COURSE_GAME_SUCCESS_TEXT"] =
  "Congratulations! You cleared this level!";
translations["MSG_COURSE_GAME_SUCCESS_REVIEW_BTN"] = "Review";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_LEVEL_BTN"] = "Next Level";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_STAGE_BTN"] = "Next Stage";
translations["MSG_COURSE_GAME_FAILED_TITLE"] = "Too bad!";
translations["MSG_COURSE_GAME_FAILED_TEXT"] =
  "Let's try again!\n\nIf it's too difficult, \nrefer to the hints.";
translations["MSG_COURSE_GAME_FAILED_RESET_BTN"] = "Try Again";
translations["MSG_COURSE_GAME_STAGE_CLEAR"] = "Congratulations! Stage cleared!";
translations["MSG_COURSE_ALL_GAME_STAGE_CLEAR"] =
  "Congratulations!\nYou've cleared all the stages\ncurrently available!\nLook forward to new stages\nbeing added!";
translations["MSG_COURSE_PROGRAM_RUN"] = "Run";
translations["MSG_COURSE_COORDINATE_X"] = "Horizontal Position (X Coordinate)";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_NEXT_BTN"] = "Next";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CONTINUE_BTN"] = "Continue Guide";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_ACTION_BTN"] = "Try it";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CLOSE_BTN"] = "End Guide";
translations["MSG_CREATOR_CREATE_APP"] = "Create New";
translations["MSG_CREATOR_CREATE_APP_TITLE"] = "Create App";
translations["MSG_CREATOR_CREATE_APP_NAME"] = "Please name the app.";
translations["MSG_CREATOR_CREATE_APP_NAME_PREFIX"] = "App";
translations["MSG_CREATOR_APP_DETAIL_BTN"] = "Details";
translations["MSG_CREATOR_RUN_APP_BTN"] = "Run";
translations["MSG_CREATOR_APP_MY_APPS"] = "My Apps";
translations["MSG_CREATOR_APP_SHARED_APPS"] = "Shared Apps";
translations["MSG_CREATOR_APP_SHARED_APPS_EMPTY_MESSAGE"] =
  "No apps found matching these criteria.\nPlease change the criteria and search again.";
translations["MSG_CREATOR_APP_DELETED_APPS"] = "Trash";
translations["MSG_CREATOR_APP_DELETED_APPS_MESSAGE"] =
  "Select the app you want to return\nto 'My Apps'.\n(Up to 5 recently deleted\napps are kept)";
translations["MSG_CREATOR_APP_SETTING_TITLE"] = "App Settings";
translations["MSG_CREATOR_APP_SETTING_APP_NAME"] = "App Name";
translations["MSG_CREATOR_APP_SETTING_APP_TAG"] = "Tag";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_TITLE"] =
  "Publish to Shared Apps";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_OFF"] = "Private";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_ON"] = "Public";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_TITLE"] =
  "Allow others to copy";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_OFF"] =
  "Disallow\nCopying";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_ON"] =
  "Allow\nCopying";
translations["MSG_CREATOR_APP_SETTING_APP_CHANGE_COVER_PAGE_BTN"] =
  "Change Cover Page";
translations["MSG_CREATOR_APP_DETAIL_APP_AUTHOR"] = "Original Creator";
translations["MSG_CREATOR_APP_DETAIL_APP_EDITOR"] = "Last Editor";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "Enter name";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_TITLE"] = "App Description";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_NONE"] = "No description";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_PLACEHOLDER"] =
  "Enter app description";
translations["MSG_CREATOR_APP_DETAIL_TITLE_APP_CODE"] = "App\nCode";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP"] = "Shared\nApp";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_PUBLISHED"] = "Public";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_NOT_PUBLISHED"] =
  "Private";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS"] = "Others";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_ENABLE"] = "Can copy";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_DISABLE"] =
  "Cannot copy";
translations["MSG_CREATOR_APP_DETAIL_APP_DELETED_AT"] = "Deletion\nDate";
translations["MSG_CREATOR_APP_EDITOR_BTN"] = "Create";
translations["MSG_CREATOR_APP_COMPLETELY_BTN"] = "Delete Permanently";
translations["MSG_CREATOR_APP_RESTORE_BTN"] = "Restore";
translations["MSG_CREATOR_APP_DELETE_WARNING_TITLE"] = "Delete app?";
translations["MSG_CREATOR_APP_DELETE_WARNING_MESSAGE"] =
  'Delete "%{name}"?\nYou will not be able to edit the app.\nYou will not be able to use the app.';
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "Delete image?";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  'Delete "%{name}"?\nOnce deleted, the image cannot be recovered.';
translations["MSG_CREATOR_CREATE_APP_PICKUP_NAME"] = "Pickup";
translations["MSG_CREATOR_CREATE_APP_PICKUP_MONTH_TITLE"] = "%{month}'s"; // e.g., "August's"
translations["MSG_CREATOR_CREATE_APP_PICKUP_SUBTITLE"] =
  "Introducing interesting apps!";
translations["MSG_CREATOR_APP_PUBLISH_TITLE"] = "Publish to 'Shared Apps'?";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_TITLE"] = "Cannot publish app";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_MESSAGE"] =
  "App publishing is not allowed.\nPlease allow it from the parent menu.";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_TITLE"] =
  "Stop publishing to 'Shared Apps'?";
translations["MSG_CREATOR_APP_PUBLISH_WARNING"] =
  "Publish \"%{name}\" to 'Shared Apps'.\nPublishing the app allows others to use it.";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_WARNING"] =
  "Stop publishing \"%{name}\" to 'Shared Apps'.\nStopping publication prevents others from using the app.";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_ENABLE"] = "Publish & Allow Copy";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_DISABLE"] =
  "Publish & Disallow Copy";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_NOTICE"] =
  "* You can unpublish the app later.";
translations["MSG_CREATOR_PUBLISH_CONFIRM_BTN"] = "Publish";
translations["MSG_CREATOR_DISABLE_PUBLISH_CONFIRM_BTN"] = "Make Private";
translations["MSG_CREATOR_APP_ENABLE_COPIED_TITLE"] =
  "Copy Setting for This App";
translations["MSG_CREATOR_APP_DISABLE_COPIED_TITLE"] =
  "Copy Setting for This App";
translations["MSG_CREATOR_APP_ENABLE_COPIED_MESSAGE"] =
  'Allow others to copy "%{name}".';
translations["MSG_CREATOR_APP_DISABLE_COPIED_MESSAGE"] =
  'Disallow others from copying "%{name}".';
translations["MSG_CREATOR_APP_LIMIT_WARNING_TITLE"] = "Cannot create app";
translations["MSG_CREATOR_APP_LIMIT_WARNING_MESSAGE"] =
  "Currently, only up to 5 apps can be created.\nIf you want to create a new app, please delete an old one.\nWe will notify you when it becomes possible to create more than 5 apps.";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_TITLE"] =
  "This image cannot be used";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_MESSAGE"] =
  "Only the latest 50 images can be added to the app.\nWe will notify you when other images become available.";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_TITLE"] =
  "Cannot delete app";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_MESSAGE"] =
  "Apps published to Shared Apps cannot be deleted.\nIf you want to delete this app, please make it private first.\n";
translations["MSG_CREATOR_TOP_TUTORIAL_APP_LIMIT_WARNING_TITLE"] =
  "Cannot run 'Guide'";
translations["MSG_CREATOR_TOP_TUTORIAL_APP_LIMIT_WARNING_MESSAGE"] =
  "One app slot is required to view this 'Guide'.\nPlease delete one app before running this 'Guide'.";
translations["MSG_CREATOR_APP_SORT_FILTER_TITLE"] = "Find";
translations["MSG_CREATOR_APP_KEYWORD_SEARCH_TITLE"] = "Find by Keyword";
translations["MSG_CREATOR_APP_SORT_TITLE"] = "Sort";
translations["MSG_CREATOR_APP_SORT_FAVORITED"] = "Popularity";
translations["MSG_CREATOR_APP_SORT_VIEWED"] = "Popularity";
translations["MSG_CREATOR_APP_SORT_DATE"] = "Time";
translations["MSG_CREATOR_APP_FILTER_TITLE"] = "Filter";
translations["MSG_CREATOR_APP_FILTER_OFFICIAL"] = "Official";
translations["MSG_CREATOR_APP_FILTER_FAVORITED"] = "Liked";
translations["MSG_CREATOR_APP_DISABLE_BTN"] = "Cannot";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_TITLE"] =
  "Permanently delete app?";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_SUBTITLE"] =
  'Permanently delete "%{name}"?\nOnce permanently deleted, the app cannot be recovered.';
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_TITLE"] = "Restore to 'My Apps'?";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_SUBTITLE"] =
  "Restore \"%{name}\" to 'My Apps'?";
translations["MSG_CREATOR_SCREEN_LIST_HEADER"] = "Pages";
translations["MSG_CREATOR_COMPONENT_LIST_HEADER"] = "Selected";
translations["MSG_CREATOR_MENU_CONTEXT_DELETE"] = "Delete";
translations["MSG_CREATOR_MENU_CONTEXT_COPY"] = "Copy";
translations["MSG_CREATOR_MENU_RUN_APP_BTN"] = "Run\nApp";
translations["MSG_CREATOR_MENU_SET_APP_BTN"] = "App\nSettings";
translations["MSG_CREATOR_MENU_PUBLISH_APP_BTN"] = "Publish\nApp";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_APP_BTN"] = "Unpublish\nApp";
translations["MSG_CREATOR_MENU_PUBLISH_TEMPLATE_BTN"] = "Publish\nTemplate";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_TEMPLATE_BTN"] =
  "Unpublish\nTemplate";
translations["MSG_CREATOR_MENU_CLOSE_BTN"] = "Close\nThis Screen";
translations["MSG_CREATOR_MENU_COMPONENT_BTN"] = "Parts";
translations["MSG_CREATOR_MENU_COMPONENT_ACTION_BTN"] = "Actions";
translations["MSG_CREATOR_MENU_COMPONENT_SHAPE_BTN"] = "Shapes";
translations["MSG_CREATOR_MENU_COMPONENT_STAMP_BTN"] = "Stamps";
translations["MSG_CREATOR_MENU_COMPONENT_STOCK_BTN"] = "Toolbox";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_ACTION"] = "Action Parts";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_SHAPE"] = "Shape Parts";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP"] = "Stamp Parts";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_CHARACTER"] = "Characters";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GAME"] = "Activities/Play";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ANIMAL"] = "Animals";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_EVENT"] = "Events";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_INTERNET"] = "Internet";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_MONEY"] = "Economy/Money";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GOODS"] = "Daily Goods";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_NATURE"] = "Nature/Plants";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_PERSON"] = "People";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_BUILDING"] = "Buildings";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_FOOD"] = "Food";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ELECTRONIC"] =
  "Electronics/Communication";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_SMILE"] = "Smiley";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_VEHICLE"] = "Vehicles";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_STATIONARY"] =
  "Stationery";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_OTHERS"] = "Others";
translations["MSG_CREATOR_MENU_DRAWING_BTN"] = "Drawing";
translations["MSG_CREATOR_MENU_DRAWING_PEN"] = "Pen";
translations["MSG_CREATOR_MENU_DRAWING_ERASER"] = "Eraser";
translations["MSG_CREATOR_MENU_DRAWING_SIZE"] = "Thickness";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_LIGHT"] = "Thin";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_NORMAL"] = "Normal";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_BOLD"] = "Thick";
translations["MSG_CREATOR_MENU_DRAWING_COLOR"] = "Color";
translations["MSG_CREATOR_MENU_DRAWING_RESET"] = "Reset";
translations["MSG_CREATOR_MENU_DRAWING_FINISH"] = "Finish";
translations["MSG_CREATOR_MENU_STOCK_PARTS_USE_BTN"] = "Add";
translations["MSG_CREATOR_MENU_COMPONENT_PREVIEW_TITLE"] = "%{name} Part List";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_SYSTEM_TITLE"] = "Icons";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "Album";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] = "Sketchbook";
translations["MSG_CREATOR_MENU_PROPERTY_BTN"] = "Design";
translations["MSG_CREATOR_MENU_PROPERTY_BASIC"] = "Basic";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION"] = "Position";
translations["MSG_CREATOR_MENU_PROPERTY_SIZE"] = "Size";
translations["MSG_CREATOR_MENU_PROPERTY_APPEARANCE"] = "Appearance";
translations["MSG_CREATOR_MENU_PROPERTY_COLOR"] = "Color";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC"] = "Program";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC_TITLE"] = "%{name}'s Program";

translations["MSG_CREATOR_MENU_PROPERTY_NAME"] = "Name";
translations["MSG_CREATOR_MENU_PROPERTY_NAME_PLACEHOLDER"] = "Enter name";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE_TITLE"] = "Top Page";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE"] = "Start from this page";
translations["MSG_CREATOR_MENU_PROPERTY_FONT_FAMILY"] = "Font Type";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT"] = "Display Content";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX"] = "Layer";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_FRONT"] = "Bring to Front";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_BACK"] = "Send to Back";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION_X_Y"] =
  "Horizontal and Vertical Position";
translations["MSG_CREATOR_MENU_PROPERTY_X"] = "Horizontal Position";
translations["MSG_CREATOR_MENU_PROPERTY_Y"] = "Vertical Position";
translations["MSG_CREATOR_MENU_PROPERTY_X_COORDINATE"] = "X";
translations["MSG_CREATOR_MENU_PROPERTY_Y_COORDINATE"] = "Y";
translations["MSG_CREATOR_MENU_PROPERTY_WIDTH"] = "Width";
translations["MSG_CREATOR_MENU_PROPERTY_HEIGHT"] = "Height";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER"] = "Border";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW"] = "Shadow";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SIZE"] = "Text";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW"] = "Text Shadow";
translations["MSG_CREATOR_MENU_PROPERTY_OPACITY"] = "Opacity";
translations["MSG_CREATOR_MENU_PROPERTY_ROTATION"] = "Angle";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_RADIUS"] = "Corner Radius";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO"] = "Image Information";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_NAME"] = "Name";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_SIZE"] = "Size";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_FILE_SIZE"] = "File Size";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_BTN"] = "Select Image";
translations["MSG_CREATOR_MENU_PROPERTY_BACKGROUND_COLOR"] = "Fill";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_COLOR"] = "Border";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW_COLOR"] = "Shadow";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_COLOR"] = "Text";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW_COLOR"] = "Text Shadow";

translations["MSG_CREATOR_MENU_BLOCKLY_TITLE"] = "Blocks";
translations["MSG_CREATOR_MENU_BLOCKLY_EVENT"] = "Events";
translations["MSG_CREATOR_MENU_BLOCKLY_ANIMATION"] = "Motion";
translations["MSG_CREATOR_MENU_BLOCKLY_CONTROL"] = "Control";
translations["MSG_CREATOR_MENU_BLOCKLY_LOGIC"] = "Logic";
translations["MSG_CREATOR_MENU_BLOCKLY_MATH"] = "Math";
translations["MSG_CREATOR_MENU_BLOCKLY_VARIABLE"] = "Variables";
translations["MSG_CREATOR_MENU_BLOCKLY_PROCEDURE"] = "Functions";
translations["MSG_CREATOR_MENU_BLOCKLY_PROMPT_INPUT_MESSAGE"] =
  "Value for %{placeholder}";

translations["MSG_CREATOR_COMPONENT_NAME_SCREEN"] = "Page";
translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"] = "Button";
translations["MSG_CREATOR_COMPONENT_NAME_LABEL"] = "Label";
translations["MSG_CREATOR_COMPONENT_NAME_FORM"] = "Form";
translations["MSG_CREATOR_COMPONENT_NAME_CHECKBOX"] = "Checkbox";
translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"] = "Switch";
translations["MSG_CREATOR_COMPONENT_NAME_IMAGE"] = "Image";
translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"] = "Circle";
translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"] = "Triangle";
translations["MSG_CREATOR_COMPONENT_NAME_RECT"] = "Rectangle";
translations["MSG_CREATOR_COMPONENT_NAME_STAR"] = "Star";
translations["MSG_CREATOR_COMPONENT_NAME_LINE"] = "Line";
translations["MSG_CREATOR_COMPONENT_NAME_STAMP"] = "Stamp";
translations["MSG_CREATOR_COMPONENT_NAME_DRAWING"] = "Drawing";
translations["MSG_CREATOR_COMPONENT_LABEL_BUTTON"] =
  translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"];
translations["MSG_CREATOR_COMPONENT_LABEL_LABEL"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LABEL"];
translations["MSG_CREATOR_COMPONENT_LABEL_FORM"] =
  translations["MSG_CREATOR_COMPONENT_NAME_FORM"];
translations["MSG_CREATOR_COMPONENT_LABEL_CHECKBOX"] = "Checkbox";
translations["MSG_CREATOR_COMPONENT_LABEL_SWITCH"] =
  translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"];
translations["MSG_CREATOR_COMPONENT_LABEL_IMAGE"] = "Image\nBox";
translations["MSG_CREATOR_COMPONENT_LABEL_CIRCLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_TRIANGLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_RECT"] = "Square"; // Changed from 四角 (Shikaku) to Square for better fit
translations["MSG_CREATOR_COMPONENT_LABEL_STAR"] =
  translations["MSG_CREATOR_COMPONENT_NAME_STAR"];
translations["MSG_CREATOR_COMPONENT_LABEL_LINE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LINE"];

translations["MSG_BLOCKLY_VARIABLES"] = "Variables";
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "Please enter a number.";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] =
  "Please enter within %{limit} characters.";
translations["MSG_ASSET_ALBUM_TITLE"] = "Album Contents";
translations["MSG_ASSET_DRAWING_TITLE"] = "Sketchbook Contents";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "Add Image";
translations["MSG_ASSET_DRAWING_ADD_ALBUM_TITLE"] =
  "Images and photos added in 'Manande Puzzle' will be added here.";
translations["MSG_ASSET_DRAWING_ADD_WARNING_TITLE"] =
  "Drawings made in the 'Drawing' menu of 'Create Freely' will be added here.";
translations["MSG_ASSET_ADD_TO_SCREEN_BTN"] = "Add to\nApp";
translations["MSG_ASSET_DELETE_BTN"] = "Delete\nImage";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] = "No image data yet.";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] = "No drawing data yet.";
translations["MSG_REACTION_TAG_TITLE"] = "Feeling Stamps";
translations["MSG_REACTION_USERS"] = "Everyone's\nFeelings";
translations["MSG_REACTION_DIFFICULT"] = "Tough!";
translations["MSG_REACTION_EASY"] = "Easy";
translations["MSG_REACTION_COOL"] = "Cool!";
translations["MSG_REACTION_FUN"] = "Fun";
translations["MSG_REACTION_AMAZING"] = "Amazing";
translations["MSG_REACTION_BAD"] = "Hmm?";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_LATER_BTN"] = "See later";

// User Plan
translations["MSG_CURRENT_PLAN"] = "Current Plan";
translations["MSG_PLAN_TRIAL"] = "Trial";
translations["MSG_PLAN_SAKIDORI"] = "Early Access";
translations["MSG_PLAN_FREE"] = "Free";
translations["MSG_PLAN_STANDARD"] = "Standard";
translations["MSG_PLAN_PREMIUM"] = "Premium";
translations["MSG_PLAN_EDUCATION"] = "School";
translations["MSG_PLAN_UNKNOWN"] = "Unknown";

export default translations;
